<template>
	<div class="__klarna">

		<div class="__placeholders">
			<span class="__placeholder _h">Dynamically generated</span>
			<span class="__placeholder _2"></span>

			<span class="__placeholder _3">
				For maximum conversions and optimal checkout experience;
				we will generate the contents of this payment option based on the end-customer's preferences and eligibility.
			</span>
		</div>
	</div>
</template>

<script>
import VSwitch from "@/components/base/v-switch";
import EditableSpan from "@/modules/page-editor/src/components/base/editable-span";
export default {
	name: "klarna", components: {EditableSpan, VSwitch},
	props:{
		method:{},
	},
	computed:{
	}
}
</script>

<style lang="scss" scoped>
.__klarna {
	.__placeholders {
		display: flex;
		flex-direction: column;
		gap: 10px;
		margin: 0 20px 0;

		.__placeholder {
			background: $light-silver;
			border-radius: 5px;
			height: 20px;
			width: 200px;
			color: #3e3e3f;
			font-size: .94rem;
			line-height: 1.5;
			font-weight: 500;
			&._h {
				height: fit-content;
				padding: 4px 10px;
				font-weight: 700;
			}
			&._2 {
				width: 100%;
			}
			&._3 {
				font-style: italic;
				width: 100%;
				height: fit-content;
				padding: 5px 10px;
			}
		}
	}
}
</style>
